export default "__VITE_ASSET__87fc07e3__"